module.exports = __webpack_public_path__ + "img/helal.5ec6706.webp";